import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { dateKey } from '../../../shared/lib/format';
import { useWorkspace } from '../../stores';
import { listAppointments } from '../api/appointmentsApi';

export function useAppointments(from: string, to: string) {
  const { isDemo, store, scopeKey, timezone } = useWorkspace();
  const demo = useDemo();
  return useQuery({
    queryKey: [...scopeKey, 'appointments', from, to, isDemo ? demo.revision : 0],
    queryFn: ({ signal }) => isDemo
      ? Promise.resolve(demo.appointments.filter(item => item.store_id === store?.id && dateKey(item.appointment_time_ms, timezone) >= from && dateKey(item.appointment_time_ms, timezone) <= to))
      : listAppointments(from, to, timezone, signal),
    enabled: Boolean(store?.id),
    staleTime: isDemo ? 0 : 30_000,
    refetchInterval: isDemo ? false : 60_000,
  });
}
